module.exports = __webpack_public_path__ + "static/img/Man SLG.b9a863a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Man SLG.jpg
// module id = 3kkl
// module chunks = 1